export const makeDataColumnInteger = (worksheet, object) => {
  const changes = [];

  for (let i = 1; i <= worksheet.rowCount; i++) {
    const cellContent = worksheet.getCell(`${object.inColChr}${i}`).value;
    if (cellContent) {
      const replace = makeNumeric(cellContent);

      // Track changes only if value actually changed
      if (replace !== cellContent) {
        changes.push({
          rowIndex: i,
          originalValue: cellContent,
          convertedValue: replace,
        });
      }

      worksheet.getCell(`${object.inColChr}${i}`).value =
        replace ?? cellContent;
    }
  }

  return changes;
};

export function makeNumeric(value, forceInteger = false) {
  // Handle null, undefined, or already numeric values
  if (value === null || value === undefined || value === "") {
    return null;
  }

  // If already a number, just return it as-is
  if (typeof value === "number") {
    return forceInteger ? Math.floor(value) : value;
  }

  // Convert to string for processing
  let str = value.toString().trim();

  // If empty after trim, return null
  if (!str) {
    return null;
  }

  // Remove all non-digit, non-decimal point, non-negative sign characters
  // This handles: currency symbols, letters, commas, spaces, etc.
  // Keep only: digits (0-9), decimal point (.), and minus sign (-)
  let numericStr = str.replace(/[^\d.-]/g, "");

  // Handle multiple decimal points - keep only the last one
  let parts = numericStr.split(".");
  if (parts.length > 2) {
    // If multiple decimal points, assume the last one is the decimal separator
    // Join all parts except the last, then add the last part as decimal
    numericStr = parts.slice(0, -1).join("") + "." + parts[parts.length - 1];
  }

  // Handle multiple minus signs - keep only the first one if at the beginning
  if (numericStr.includes("-")) {
    let isNegative = numericStr.charAt(0) === "-";
    numericStr = numericStr.replace(/-/g, "");
    if (isNegative) {
      numericStr = "-" + numericStr;
    }
  }

  // Convert to number
  let result = parseFloat(numericStr);

  // Return null if not a valid number
  if (isNaN(result)) {
    return null;
  }

  // Handle integer conversion or decimal cleanup
  if (forceInteger) {
    return Math.floor(result); // Use floor instead of round to avoid rounding up
  } else {
    // Return exact decimal value without rounding
    return result;
  }
}
